import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import InternalMenu from "./components/InternalMenu";
import ChatPage from "./pages/ChatPage";
import ContentsPage from "./pages/ContentsPage";
import CreateAccountPage from "./pages/CreateAccountPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import HistoryItemPage from "./pages/HistoryItemPage";
import HistoryPage from "./pages/HistoryPage";
import IntegrationsPage from "./pages/IntegrationsPage";
import ToolsPage from "./pages/ToolsPage";
import IntercomIntegrationPage from "./pages/IntercomIntegrationPage";
import LoginPage from "./pages/LoginPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SettingsPage from "./pages/SettingsPage";
import BillingPage from "./pages/BillingPage";
import CampaignPage from "./pages/CampaignPage";
import CampaignEntriesPage from "./pages/CampaignEntriesPage";
import ZendeskTicketingIntegrationPage from "./pages/ZendeskTicketingIntegrationPage";
import ZendeskMessagingIntegrationPage from "./pages/ZendeskMessagingIntegrationPage";

const theme = createTheme({
    palette: {
        primary: {
            main: "#0359D6",
        },
    },
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Routes>
                    <Route path="/" element={<LoginPage />} />
                    <Route path="/register" element={<CreateAccountPage />} />
                    <Route
                        path="/forgot-password"
                        element={<ForgotPasswordPage />}
                    />
                    <Route
                        path="/forgot-password/:token"
                        element={<ResetPasswordPage />}
                    />
                    <Route path="/chat/:tenantId" element={<ChatPage />} />
                    <Route
                        path="/chat/"
                        element={
                            <InternalMenu>
                                <ChatPage />
                            </InternalMenu>
                        }
                    />

                    <Route
                        path="/training"
                        element={
                            <InternalMenu>
                                <ContentsPage />
                            </InternalMenu>
                        }
                    />
                    <Route
                        path="/history"
                        element={
                            <InternalMenu>
                                <HistoryPage />
                            </InternalMenu>
                        }
                    />
                    <Route
                        path="/history/:sessionId"
                        element={
                            <InternalMenu>
                                <HistoryItemPage />
                            </InternalMenu>
                        }
                    />
                    <Route
                        path="/settings"
                        element={
                            <InternalMenu>
                                <SettingsPage />
                            </InternalMenu>
                        }
                    />
                    <Route
                        path="/integrations"
                        element={
                            <InternalMenu>
                                <IntegrationsPage />
                            </InternalMenu>
                        }
                    />
                    <Route
                        path="/chiko-connect"
                        element={
                            <InternalMenu>
                                <ToolsPage />
                            </InternalMenu>
                        }
                    />
                    <Route
                        path="/billing"
                        element={
                            <InternalMenu>
                                <BillingPage />
                            </InternalMenu>
                        }
                    />
                    <Route
                        path="/campaigns"
                        element={
                            <InternalMenu>
                                <CampaignPage />
                            </InternalMenu>
                        }
                    />
                    <Route
                        path="/campaigns/:campaignId"
                        element={
                            <InternalMenu>
                                <CampaignEntriesPage />
                            </InternalMenu>
                        }
                    />
                    <Route
                        path="/oauth2/intercom/authorize/"
                        element={
                            <InternalMenu>
                                <IntercomIntegrationPage />
                            </InternalMenu>
                        }
                    />
                    <Route // Zendesk Ticketing
                        path="/oauth2/zendesk/authorize/"
                        element={
                            <InternalMenu>
                                <ZendeskTicketingIntegrationPage />
                            </InternalMenu>
                        }
                    />
                    <Route // Zendesk Messaging
                        path="/oauth2/zendesk-messaging/authorize/"
                        element={
                            <InternalMenu>
                                <ZendeskMessagingIntegrationPage />
                            </InternalMenu>
                        }
                    />
                    <Route path="*" element={<LoginPage />} />
                </Routes>
            </Router>
        </ThemeProvider>
    );
}

export default App;
